module.exports = __webpack_public_path__ + "static/media/profile_email.5170731c.svg";